module.exports = __webpack_public_path__ + "img/osm.22927f85.png";